import { render, staticRenderFns } from "./GinCreate.vue?vue&type=template&id=6e42efeb&scoped=true"
import script from "./GinCreate.vue?vue&type=script&lang=js"
export * from "./GinCreate.vue?vue&type=script&lang=js"
import style0 from "./GinCreate.vue?vue&type=style&index=0&id=6e42efeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42efeb",
  null
  
)

export default component.exports